<template>
    <div class="ma-0 pa-0">
      <!-- //* input for adding the file -->
      <input type="file" ref="fileinput" style="display: none" @change="previewFile" :accept="GET_photoUpload.allowedTypes"/>
      <!-- //* upload button -->
      <appbutton label="ADD PHOTO"  icon="icons8-camera"  type="darkgrey"  @click.native="fileClick" /> 
      <!-- //* upload progress row -->
      <v-row class="px-1 py-0 mb-0" v-if="hideUploadButton === false && isUploading">
        <v-progress-linear v-model="uploadValue" height="25">
            <strong>{{ Math.ceil(uploadValue) }}%</strong>
        </v-progress-linear>
      </v-row>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
    // * DATA
    data: () => ({
        fileData: null,
        fileType: '',
        hideUploadButton: false,
    }),
    computed: {
        ...mapGetters({
            GET_photoUpload: 'photoUpload_store/GET_photoUpload'
        })
    },
    // * WATCH
    watch: {
        fileData: async function() {
            var t = this;
            var uploadFileResult = await t.MIX_uploadFile(t.GET_photoUpload.folder, t.fileData, t.GET_photoUpload.type, t.GET_photoUpload.typeId );
            t.MIX_photoUploadResult(uploadFileResult.data);
        },
    },
    // * METHODS
    methods: {
        fileClick() {
            this.$refs.fileinput.click();
        },
        previewFile: async function(event) {
            this.uploadValue = 0;
            this.fileURL = null;
            this.fileData = event.target.files[0]; // asign fileData for preview
        },
    }
}
</script>